// NOTE: these are bad checks because they limit component maintainability
// TODO: find ways to remove them from code and replace them with something better

import fromAnyToString from 'utils/converters/fromAnyToString';

const indexOf = (needle, haystack) => fromAnyToString(haystack).indexOf(needle);

export const fromPathnameToIsWeekLocked = (path) => path.includes('dashboard') || path.includes('performance');

export const fromPathnameToIsBucket = (path) => 0 < indexOf('buckets', path);
export const fromPathnameToNotBuckets = (path) => 0 > indexOf('buckets', path);
export const fromPathnameToIsMonthlyDashboard = (path) => 0 <= indexOf('monthly-dashboard', path);
export const fromPathnameToNotMonthlyDashboard = (path) => 0 > indexOf('monthly-dashboard', path);
export const fromPathnameToNotDashboard = (path) => 0 > indexOf('dashboard', path);
export const fromPathnameToIsApNewServices = (path) => 0 < indexOf('appointment/new/services', path);
export const fromPathnameToIsNewAppointment = (path) => 0 < indexOf('/appointment/new', path);
export const fromPathnameToIsEditAppointment = (path) => 0 < indexOf('appointment/edit/', path);
export const fromPathnameToIsStylistsSettings = (path) => 0 < indexOf('settings/stylists', path);

// NOTE: another way of checking the same as fromPathnameToIsWeek and fromPropsToIsWeek
export const fromPathnameToIsWeekViaIndex = (path) => 0 < indexOf('week/', path);

// TODO: should delete fromPropsToIsWeek from src/utils/converters/props/path.util.js and use this
export const fromPathnameToIsWeek = (path) => fromAnyToString(path).includes('/week/');
